/**
 * Maintenance API Service
 *
 * Client-side API functions for maintenance status.
 * Uses public endpoint (no authentication required).
 */

import type { MaintenanceStatusResponse } from 'shared-types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

/**
 * Get current maintenance status from backend
 * Public endpoint - no authentication required
 *
 * @returns Promise with maintenance status
 * @throws Error if request fails
 */
export async function getMaintenanceStatus(): Promise<MaintenanceStatusResponse> {
  const response = await fetch(`${API_URL}/maintenance/status`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch maintenance status: ${String(response.status)}`);
  }

  const result = (await response.json()) as { success: boolean; data?: MaintenanceStatusResponse };

  if (!result.success || !result.data) {
    throw new Error('Invalid maintenance status response');
  }

  return result.data;
}
